import { inject, Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { ApiService } from "../api.service";
import { Router } from "@angular/router";
import IUser from "../../models/IUser";
@Injectable({
  providedIn: "root"
})
export class SharedService {
  favouriteAdvisors: any = [];
private router=inject(Router);
 private location=inject(Location)
  private isAuthenticated = new BehaviorSubject(localStorage.getItem("user") ? true : false);
  authenticated = this.isAuthenticated.asObservable();
  private breadCrumbs = new BehaviorSubject([]);
  breadCrumbsArray = this.breadCrumbs.asObservable();
  private spinner = new BehaviorSubject(false);
  showSpinner = this.spinner.asObservable();
  private buttonSpinner = new BehaviorSubject(false);
  showButtonSpinner = this.buttonSpinner.asObservable();
  private toast = new BehaviorSubject({ auto_close: false });
  showToast = this.toast.asObservable();
  private user = new BehaviorSubject(JSON.parse(localStorage.getItem("user") || "false"));
  userDetail = this.user.asObservable();

  constructor( 
  ) {
    // this.checkToken();
    // this.checkUserDetail();
  }

  // async checkToken() {
  //   if (!localStorage.getItem('token')) {
  //     this.isAuthenticated.next(false);
  //     return;
  //   }
  //   let res: any = await this.apiService.verifyToken(URLConfig.verifyToken, {
  //     token: localStorage.getItem('token')
  //   });
  //   if (res.token_verified) {
  //     this.isAuthenticated.next(true);
  //   }
  // }
  private subject = new Subject<any>();

  triggerInterceptor() {
    //Passing fake value
    this.subject.next(true);
  }

  getCurrentUser(): IUser {
    let user!: IUser;
    this.userDetail.subscribe((u) => {
      user = u;
    });
    return user;
  }

  encodeId(id: string): string {
    return btoa(String(id));
  }

  decodeId(encodedId: string): string {
    return atob(encodedId).toString();
  }

  scrollToSection(Id: string): void {

    // Replace 'sectionId' with the actual ID of the section you want to scroll to.
    const sectionId = Id;

    const section = document.getElementById(sectionId);
    if (section) {
      // Adjust the offset value as needed to control the scrolling position.
      const offset = 20;

      window.scrollTo({
        top: section.offsetTop - offset,
        behavior: "smooth" // Add smooth scrolling effect,
      });
    }
  }

  getTriggeredInterceptor(): Observable<any> {
    return this.subject.asObservable();
  }

  updateUser(obj: any) {
    this.user.next(obj);
    if (obj) {
      localStorage.setItem("user", JSON.stringify(obj));
    }
  }

  userAuthenticated(value: any) {
 
    this.isAuthenticated.next(value);
  }

  updateBreadCrumbs(value: any) {
    this.breadCrumbs.next(value);
  }

  showHideSpinner(value: any) {
    this.spinner.next(value);
  }

  showHideButtonSpinner(value: any) {
    this.buttonSpinner.next(value);
  }

  showHideToast(value: any) {
    this.toast.next(value);
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.userAuthenticated(false);
    this.router.navigate(["/"]);
  }

  featureNotSupported() {
    this.showHideToast({
      type: "warning",
      message: "This feature is not supported yet",
      title: "Feature in Progress"
    });
  }

  featureNotSupportedOnLocalhost() {
    this.showHideToast({
      type: "warning",
      message: "This feature is not supported on localhost",
      title: "Localhost not supported"
    });
  }

  redirectToBack() {
    this.location.back();
  }

  //   confirmSwal(title:string,text:string){
  //     return Swal.fire({
  //       title: this.translate.instant(title),
  //       text: this.translate.instant(text),
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       cancelButtonText: this.translate.instant("CANCEL"),
  //       confirmButtonText: this.translate.instant("YES")
  //   })
  //   }

  // successSwal(title:string,message:string) {
  //     return Swal.fire({
  //         icon: "success",
  //         timer: 2000,
  //         title: this.translate.instant(title),
  //         text: this.translate.instant(message) ,
  //         showConfirmButton: false
  //     })
  // }

  // errorSwal(title: string, message: string) {
  //     return Swal.fire({
  //         icon: "error",
  //         title: this.translate.instant(title),
  //         text: this.translate.instant(message) ,
  //         showConfirmButton: true
  //     })
  // }

  goBack() {
    this.location.back();
  }

  stringToNumber(stringNumber: string) {
    return parseInt(stringNumber);
  }
}
